<template>
  <div v-loading="loading" class="ota-login-form bg-white p-12 w-full rounded z-10">
    <h1 class="mb-6 o-heading-1 ota-login-form-title" v-text="$t('LoginForm.Login')" />
    <form @submit.prevent="login">
      <OInput
        id="username"
        v-model.trim="form.username"
        :label="$t('LoginForm.EmailAddress')"
        type="email"
        :required="true"
        class="mb-3"
        :input-classes="['w-full']"
      />
      <OInput
        id="password"
        v-model="form.password"
        :label="$t('LoginForm.Password')"
        type="password"
        :required="true"
        class="mb-3"
        :input-classes="['w-full']"
      />
      <NuxtLink
        to="/password-reset"
        class="ota-body-light underline mb-1"
      >
        {{ $t('LoginForm.PasswordReset') }}
      </NuxtLink>
      <div class="ota-login-form-button text-right pt-5">
        <OButton type="submit" variant="success">
          {{ $t('LoginForm.Login') }}
        </OButton>
      </div>
    </form>
  </div>
</template>

<script>
import OInput from '@/components/OInput'
import OButton from '@/components/OButton'
import { CountryCodes } from '@/enums/general'

export default {
  name: 'LoginForm',
  components: {
    OInput,
    OButton
  },
  props: {
    country: {
      type: String,
      default: CountryCodes.netherlands
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      form: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    oldPasswordResetLink () {
      let passwordResetLink

      switch (this.country) {
        case 'nl':
          passwordResetLink = 'https://onthatass.com/wachtwoord-vergeten'
          break
        case 'fr':
          passwordResetLink = 'https://onthatass.com/forgot-password'
          break
        case 'es':
          passwordResetLink = 'https://onthatass.com/forgot-password'
          break
        case 'de':
          passwordResetLink = 'https://onthatass.com/passwort-vergessen'
          break
        case 'at':
          passwordResetLink = 'https://onthatass.com/passwort-vergessen'
          break
        case 'be':
          passwordResetLink = 'https://onthatass.com/wachtwoord-vergeten'
          break
        default:
          passwordResetLink = 'https://onthatass.com/forgot-password'
      }

      return passwordResetLink
    }
  },
  methods: {
    login () {
      this.$emit('login', this.form)
    }
  }
}
</script>

<style>

</style>
